
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class HolidaysDialog extends _Ext.EditorDialogBase<HolidaysRow> {
        protected getFormKey() { return HolidaysForm.formKey; } 

        protected getLocalTextPrefix() { return HolidaysRow.localTextPrefix; }
        protected getNameProperty() { return HolidaysRow.nameProperty; } 

        protected form = new HolidaysForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
    }
}